export class OperationType {

    public id: number;
    public name: string;
    public inUse: boolean;
    public priority: number;

    constructor(operationType: any = {}) {
        this.id = operationType.id;
        this.name = operationType.name;
        this.inUse = operationType.inUse;
        this.priority = operationType.priority;
    }

    get type() {
        return "operation-type";
    }
}
